import ZContainer from '@/ZForms/parsers/entities/ZEntityContainer';


export default window.ZForms.registerClass('container.pie_chart', class ZPieChartForm extends ZContainer {
  constructor() {
    super(...arguments);
    this.dataDimensionField = null;
    this.rowsDimensionIdx = null;
    this.columnsDimensionIdx = null;
    this.rowsDimension = null;
    this.columnsDimension = null;
  }

  async _updateMetaFromRaw(rawData) {
    await super._updateMetaFromRaw(rawData);
    this.dataDimensionField = (
        rawData.chart_settings != null && rawData.chart_settings.data_dimension_field != null ?
        this.contentMeta.fields[rawData.chart_settings.data_dimension_field] :
        this.dataDimensionField
    );

    this.rowsDimensionIdx = (
        rawData.chart_settings != null && rawData.chart_settings.rows_dimension_idx != null ?
        rawData.chart_settings.rows_dimension_idx :
        this.rowsDimensionIdx
    );
    this.columnsDimensionIdx = (
        rawData.chart_settings != null && rawData.chart_settings.columns_dimension_idx != null ?
        rawData.chart_settings.columns_dimension_idx :
        this.columnsDimensionIdx
    );

    if (this.rowsDimensionIdx == null && this.columnsDimensionIdx == null) {
      this.rowsDimensionIdx = 0;
      this.columnsDimensionIdx = 1;
    }

    this.rowsDimensionIdx = this.rowsDimensionIdx == null ? (this.columnsDimensionIdx + 1) % 2 : this.rowsDimensionIdx;
    this.columnsDimensionIdx = this.columnsDimensionIdx == null ? (this.rowsDimensionIdx + 1) % 2 : this.columnsDimensionIdx;

    this.rowsDimension = this.dataDimensionField.dimensions[this.rowsDimensionIdx];
    this.columnsDimension = this.dataDimensionField.dimensions[this.columnsDimensionIdx];
  }
});
